import React, { useEffect, useRef, useState } from 'react'
import HatchPatternForm from './HatchPatternForm'
import DynamicForm from '../../../../../components/DynamicForm'
import Button from '../../../../../components/UiElements/Button'

const HatchPattern = ({ item, close, submit, data, change }) => {
  const myFormRef = useRef(null)

  const handleSaveHatchPattern = async () => {
    const formData = await myFormRef?.current?.getData()
    if (item?.create) {
      const patternArray = data?.hatch_patterns || []
      patternArray.push(formData)
      change(patternArray, 'hatch_patterns')
      submit(patternArray.length + 1)
    } else {
      submit(formData)
    }

    close()
  }
  return (
    <div className={'flex flex-col gap-md'}>
      <div className={'py-xl mx-xl grid grid-cols-12 gap-md border-b-gray-200 border-b '}>
        <DynamicForm
          items={HatchPatternForm}
          defaultValues={{ ...Object.values(data)[item.index] }}
          size={'md'}
          ref={myFormRef}
        />
      </div>
      <div className={'col-span-12 pb-xl  px-xl flex flex-col justify-end '}>
        <Button
          onClick={() => {
            handleSaveHatchPattern()
          }}
        >
          Save Hatch Pattern
        </Button>
      </div>
    </div>
  )
}

const HatchPatternList = ({ value, data, submit, item }) => {
  const [formView, setFormView] = useState(null)
  const [innerData, setInnerData] = useState(null)
  const myFormRef = useRef(null)

  useEffect(() => {
    const view = (defaultValues = { _list: [] }) => {
      //value
      return (
        defaultValues?._list?.map((item, index) => ({
          name: `hatch_patterns.${index}`,
          type: 'PopUp',
          labelClassName: 'hidden',
          innerClassName: 'w-[450px] !z-[301]',
          className: ' ',
          module: HatchPattern,
          view: OpenHatchProfileFrom,
          title: 'Hatch Pattern',
          index: index,
          defaultValue: item,
          innerData: defaultValues?._list,
        })) || []
      )
    }
    setFormView({ view: view })
    setInnerData(data?.hatch_patterns)
  }, [data, item])

  useEffect(() => {
    if (typeof value === 'object' && value !== null) {
      const deleteFalseData = Object.values(value).filter((item) => item !== false)
      submit(deleteFalseData)
    }
  }, [value, submit])

  return (
    <>
      {formView && innerData && (
        <div className={'flex flex-col gap-sm '}>
          <DynamicForm
            items={formView.view}
            defaultValues={{ _list: innerData }}
            size={'md'}
            ref={myFormRef}
            onChange={(val) => {
              const deleteFalseData = Object.values(val).filter((item) => item !== false)
              submit(deleteFalseData)
            }}
          />
        </div>
      )}
    </>
  )
}

const OpenHatchProfileFrom = ({ show, item, submit }) => {
  const [innerData, setInnerData] = useState(item?.innerData?.[item?.index])

  useEffect(() => {
    setInnerData(item?.innerData?.[item?.index])
  }, [item])

  const handleDelete = () => {
    submit(false)
  }

  const handleOpenFrom = () => {
    show()
  }

  return (
    <div
      onClick={() => handleOpenFrom()}
      className=" flex items-center group justify-between bg-gray-100 rounded-md pl-md pr-[5px] h-[44px] self-stretch text-gray-900 text-title-md capitalize select-none hover:bg-gray-200 transition cursor-pointer"
    >
      <div className="flex flex-row gap-sm">
        {innerData?.hatch_type.replace(/_/g, ' ')} Hatch
        <span className="text-gray-400 text-text-md group-hover:text-gray-900 transition flex flex-row gap-sm">
          <span className="font-icon-light text-gray-400"></span>Edit
        </span>
      </div>
      <div className="flex flex-row gap-xs opacity-0 group-hover:opacity-100 transition">
        <div
          onClick={(e) => {
            handleDelete()
            e.stopPropagation()
          }}
          className="text-red-500 text-sm font-icon-regular w-[34px] h-[34px] flex items-center justify-center hover:bg-red-500 hover:text-white hover:text-shadow-sm transition rounded-sm cursor-pointer"
        >
          
        </div>
      </div>
    </div>
  )
}

export { HatchPatternList, OpenHatchProfileFrom, HatchPattern }
